export const SESSION_COOKIE = "4444session";